export default __webpack_public_path__ + "static/media/icon_car_inmotion.9032e732.svg";